
import {
  computed, defineComponent, PropType, reactive, ref,
} from 'vue';
import { useRoute } from 'vue-router';
import { MEDIA_TYPES, SHARE_SETTINGS } from '@/types/enums';
import BottomPopUpItem from '@/components/BottomPopUp/BottomPopUpItem.vue';
import AppBottomPopUp from '@/components/BottomPopUp/AppBottomPopUp.vue';
import AppSoloCaseSelector from '@/components/AppSoloCaseSelector.vue';
import { IMedia } from '@/types/interfaces';
import { useDriveStore } from '@/modules/drive/store/driveStore';
import AppSkeletonCaseView from '@/components/skeletons/AppSkeletonCaseView.vue';
import { useMainStore } from '@/store/mainStore';
import NativeService from '@/services/NativeService';
import ToFlutterService from '@/services/ToFlutterService';

export default defineComponent({
  components: {
    BottomPopUpItem,
    AppBottomPopUp,
    AppSoloCaseSelector,
    AppSkeletonCaseView,
  },
  props: {
    file: { type: Object as PropType<IMedia>, required: true },
    type: { type: String as PropType<MEDIA_TYPES>, required: true },
  },
  emits: ['close', 'close-media', 'openMovePopUp', 'deleteMedia', 'saveMediaAsCopy', 'removeSharing', 'onInfo', 'openFileRenamePopUp'],
  setup(props, { emit }) {
    const driveStore = useDriveStore();
    const mainStore = useMainStore();
    const route = useRoute();
    const isNetwork = computed(() => route.meta.isNetwork || false);
    const isMy = computed(() => driveStore.appPhotoViewMedia?.owner?.accountId === mainStore.user.accountId);
    const allowSave = computed(() => (!isNetwork.value && isMy.value)
      || (driveStore.appPhotoViewMedia?.root && driveStore.appPhotoViewMedia?.shareSettings?.includes(SHARE_SETTINGS.ALLOW_SAVE)));

    const isPhoto = computed(() => props.type === MEDIA_TYPES.PHOTO);

    const caseViewSkeleton = ref(false);
    const caseSelector = ref(false);

    const createCaseModal = ref();

    const skeletonCase = reactive({ title: '', photosAmount: 0, filesAmount: 0 });

    const downloadUrl = computed(() => process.env.VUE_APP_MEDIA_URL + props.file.downloadUrl);

    function hidePopUp() {
      emit('close');
    }

    function openMovePopUp() {
      emit('openMovePopUp');
    }

    function downloadMedia() {
      if (isPhoto.value) {
        NativeService.downloadMedia(process.env.VUE_APP_MEDIA_URL + props.file.fileUrl);
      } else {
        NativeService.downloadFile(process.env.VUE_APP_MEDIA_URL + props.file.fileUrl, props.file.name);
      }
    }

    function downloadMediaFlutter() {
      ToFlutterService.downloadMedia(process.env.VUE_APP_MEDIA_URL + props.file.fileUrl, props?.file?.name || '');
    }

    function deleteMedia(): void {
      emit('deleteMedia');
    }

    function onInfo(): void {
      emit('onInfo');
    }

    function saveMediaAsCopy() {
      emit('saveMediaAsCopy');
    }

    function removeSharing() {
      emit('removeSharing');
    }

    function onRename() {
      emit('openFileRenamePopUp');
      hidePopUp();
    }

    return {
      hidePopUp,
      deleteMedia,
      onInfo,
      downloadMedia,
      downloadMediaFlutter,
      openMovePopUp,
      saveMediaAsCopy,
      removeSharing,
      mainStore,
      skeletonCase,
      isPhoto,
      caseViewSkeleton,
      createCaseModal,
      caseSelector,
      downloadUrl,
      isNetwork,
      isMy,
      allowSave,
      onRename,
    };
  },
});
